import React from 'react';

const Invoice = ({info_invoce}) => {

    let items = (<p>Nenhuma informação encontrada.</p>);

    if (info_invoce.length) {
        items = info_invoce.map((item, key) => {
            return (<div key={key}><b>{item.label}:</b> {item.value}</div>);
        });
    }

    return (
        <div className="md-invoice">
            {items}
        </div>
    );

}

export default Invoice;



// WEBPACK FOOTER //
// ./src/components/Invoice.js